import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsMessagingAppsWhatsappRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsMessagingAppsWhatsappRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { HelpCenterSettingsMessagingAppsWhatsappEntryPoint } from './ui/messaging-apps/whatsappConfiguration.tsx';

export const helpCenterSettingsMessagingAppsWhatsappRouteEntry: Route = createEntry(
	helpCenterSettingsMessagingAppsWhatsappRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.messaging-apps-whatsapp',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		entryPoint() {
			return fg('csm-omni-whatsapp-support')
				? HelpCenterSettingsMessagingAppsWhatsappEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getServiceDeskNavigationResources(),
			serviceDeskContextResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
